import { useMemo } from 'react';
import moment from 'moment';
import { IShopSalesAutomation } from '../../modules/types';
import { getAnniversaryWindow } from '../../common/get-anniversary-window';
import { doStrategiesOverlap } from '../../common/do-strategies-overlapped';

export const useSalesAutomationValidation = (automationState: IShopSalesAutomation) => {
  const { couponCodeAdvertising, couponCodeAfterPurchase, anniversaryCouponCodeAdvertising } =
    automationState;

  const isOneCouponUsedTwice = useMemo(
    () =>
      !!(
        couponCodeAdvertising?.couponId &&
        couponCodeAfterPurchase?.couponId &&
        couponCodeAfterPurchase?.couponId === couponCodeAdvertising?.couponId
      ),
    [couponCodeAdvertising?.couponId, couponCodeAfterPurchase?.couponId]
  );

  const isOneAnniversaryCouponUsedTwice = useMemo(
    () =>
      !!(
        anniversaryCouponCodeAdvertising?.couponId &&
        couponCodeAfterPurchase?.couponId &&
        couponCodeAfterPurchase?.couponId === anniversaryCouponCodeAdvertising?.couponId
      ),
    [anniversaryCouponCodeAdvertising?.couponId, couponCodeAfterPurchase?.couponId]
  );

  const anniversaryWindow = useMemo(
    () => getAnniversaryWindow(moment(anniversaryCouponCodeAdvertising?.anniversaryDate).toDate()),
    [anniversaryCouponCodeAdvertising?.anniversaryDate]
  );

  const { startsAt, endsAt } = couponCodeAdvertising || {};

  const isStrategiesOverlap = useMemo(
    () =>
      !!(
        anniversaryCouponCodeAdvertising?.enabled &&
        couponCodeAdvertising?.enabled &&
        doStrategiesOverlap({
          anniversaryStartsAt: anniversaryWindow.startsAt,
          anniversaryEndsAt: anniversaryWindow.endsAt,
          startsAt: moment(startsAt).toDate(),
          endsAt: moment(endsAt).toDate()
        })
      ),
    [
      anniversaryCouponCodeAdvertising?.enabled,
      couponCodeAdvertising?.enabled,
      anniversaryWindow.startsAt,
      anniversaryWindow.endsAt,
      startsAt,
      endsAt
    ]
  );

  return {
    isOneCouponUsedTwice,
    isOneAnniversaryCouponUsedTwice,
    isStrategiesOverlap,
    anniversaryWindow
  };
};
